// extracted by mini-css-extract-plugin
export var avatar = "_a-6";
export var brandLink = "_a-0";
export var brandLogo = "_a-1";
export var gear = "_a-7";
export var gearActive = "_a-8";
export var navIcon = "_a-5";
export var navItem = "_a-3";
export var navItemActive = "_a-4";
export var sectionLabel = "_a-2";